import route from "@/components/router/Router"
const routes = [
    {
        path : "warehouse-item-add",
        name : "warehouse-item-add",
        meta : {
            title : "仓库项目-项目录入"
        },
        component: () => import('@/pages/warehouse/input/Index')
    },
    {
        path : "warehouse-item-edit/:id",
        name : "warehouse-item-edit",
        meta : {
            title : "仓库项目-项目录入"
        },
        component: () => import('@/pages/warehouse/input/Index')
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/router/warehouse/inputitem/index.js